/* eslint-disable import/no-unresolved */
import PropTypes from 'prop-types';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import { Container } from '@material-ui/core';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useSettings from 'src/hooks/useSettings';
import { useEffect } from 'react';
import SegmentationPage from 'src/components/_dashboard/collection-data/segmentation/SegmentationPage';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack5';
import { resetError, resetSuccess } from 'src/redux/slices/campaignrules';

Segmentation.propTypes = {
  isEdit: PropTypes.bool
};

export default function Segmentation({ isEdit }) {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { error, isError, isSuccess, success } = useSelector((state) => state.campaignrules);

  useEffect(() => {
    if (isError && error) {
      enqueueSnackbar(error, {
        variant: 'error'
      });
      dispatch(resetError());
    } else if (isSuccess && success) {
      enqueueSnackbar(success, {
        variant: 'success'
      });
      dispatch(resetSuccess());
    }
  }, [isError, error, isSuccess, success, dispatch]);

  return (
    <Page title="Segmentation | Smart Collect">
      <Container maxWidth={themeStretch ? false : 'lg'} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
        <HeaderBreadcrumbs
          heading={!isEdit ? 'Segmentation' : 'Edit Segmentation'}
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Collection Data', href: PATH_DASHBOARD.general.collection },
            { name: 'Segmentation', href: PATH_DASHBOARD.general.segmentation }
          ]}
        />
        <SegmentationPage />
      </Container>
    </Page>
  );
}
